import { BOOK_CREATE_GQL, BOOK_DELETE_GQL, BOOK_SET_CREATOR_GQL, BOOK_UPDATE_GQL } from './gql';
import { apolloClient } from '../client';
import { Book } from '../types.generated';

export const createBookMutation = async (
  payload: Omit<Book, 'id' | 'authors'> & { authors: string[] },
): Promise<Book | undefined> => {
  const response = await apolloClient.mutate<{ createBook: Book }>({
    mutation: BOOK_CREATE_GQL,
    variables: {
      input: payload,
    },
    refetchQueries: () => ['books', 'authors'],
  });

  return response.data?.createBook;
};

export const updateBookMutation = async (
  payload: Omit<Book, 'authors'> & { authors: string[] },
): Promise<Book | undefined> => {
  const { id, ...restData } = payload;
  const response = await apolloClient.mutate<{ updateBook: Book }>({
    mutation: BOOK_UPDATE_GQL,
    variables: {
      id,
      input: restData,
    },
    refetchQueries: () => ['books', 'authors'],
  });

  return response.data?.updateBook;
};

export const deleteBookMutation = async (id: string): Promise<string | undefined> => {
  const response = await apolloClient.mutate<{ deleteBook: Book['id'] }>({
    mutation: BOOK_DELETE_GQL,
    variables: {
      id,
    },
    refetchQueries: () => ['books', 'authors'],
  });

  return response.data?.deleteBook;
};

export const setBookCreatorMutation = async ({ bookId, createdBy }): Promise<string | undefined> => {
  const response = await apolloClient.mutate<any>({
    mutation: BOOK_SET_CREATOR_GQL,
    variables: {
      bookId,
      createdBy,
    },
    refetchQueries: () => ['books', 'authors'],
  });

  return response.data?.setBookCreator;
};
